import { Link } from "react-router";

/**
 * The Facet mark (brand package "Fresh"): a diamond in four triangles, Sun top-left, Coral
 * top-right, Leaf bottom-left, Teal bottom-right, with white seams. The seam sits a little above
 * the middle, as in the package. Below 16 px it's `solid` (no seams). Don't stretch, reorder,
 * rotate or add effects. `tone`: full colour, or one colour (`ink`, or `reversed`: white on Teal).
 */
export function FacetMark({
  size = 24,
  solid = size < 16,
  tone = "color",
  className,
}: {
  size?: number;
  solid?: boolean;
  tone?: "color" | "ink" | "reversed";
  className?: string;
}) {
  const fills =
    tone === "ink"
      ? ["#141619", "#141619", "#141619", "#141619"]
      : tone === "reversed"
        ? ["#ffffff", "#ffffff", "#ffffff", "#ffffff"]
        : ["#FFC233", "#FF6F59", "#2ED47A", "#12A4B6"];
  const seam = tone === "reversed" ? "#0B6E7A" : "#ffffff";
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true" focusable="false" className={className}>
      <path d="M50 2 L2 46 L50 46 Z" fill={fills[0]} />
      <path d="M50 2 L98 46 L50 46 Z" fill={fills[1]} />
      <path d="M2 46 L50 98 L50 46 Z" fill={fills[2]} />
      <path d="M98 46 L50 98 L50 46 Z" fill={fills[3]} />
      {solid ? null : <path d="M50 2 V98 M2 46 H98" stroke={seam} strokeWidth={size < 32 ? 6 : 3.5} />}
    </svg>
  );
}

/** The horizontal lockup: the mark, then "Gifts" ExtraBold and "Profile" Regular. Change it here only. */
export function Wordmark({ link = true, size = 22 }: { link?: boolean; size?: number }) {
  const mark = (
    <span className="inline-flex items-center gap-2 text-ink" style={{ fontSize: Math.round(size * 0.82) }}>
      <FacetMark size={size} />
      <span className="leading-none tracking-[-0.01em]">
        <span className="font-extrabold">Gifts</span> <span className="font-normal">Profile</span>
      </span>
    </span>
  );
  if (!link) return mark;
  return (
    <Link to="/" className="inline-flex min-h-11 items-center no-underline" aria-label="Gifts Profile, home">
      {mark}
    </Link>
  );
}
